module.exports = __webpack_public_path__ + "img/code.b0da59d0.png";